import { NamedEntityDto } from '../clinical-details';
import type { ImageType } from '@dermloop/static-values';

export class ImageQualityRatingReasonDto extends NamedEntityDto {
  requiresUserInput: boolean;

  isImmersionFluidRelated: boolean;

  imageTypes: ImageType[] | undefined;

  reasonFeedback: ImageQualityRatingReasonFeedbackDto[] | undefined;
}

export class ImageQualityRatingReasonFeedbackDto extends NamedEntityDto {
  imageType: ImageType;
}
